<template>
  <div class="home windows">
    <transition type="transition" name="fadee" mode="out-in" appear>
      <time-zone v-if="timeZoneCmp" @emitTimeZone="getTimeZoneFromEmit($event)"></time-zone>
    </transition>

    <div class="flex">
      <header>
        <!-- center txt -->
        <span style="font-size: 20px;" name="countryName">
          <i style="display:inline;" class="fas fa-map-marker-alt"></i>
          &nbsp;
          {{ countryName }} - {{ cityName }} 
        </span>
        <span dir="ltr" name="mainClock" class="clock">
          <span dir="rtl"> {{ testTimerCopy }} <span v-if="loadingCircle" class="loadingCircle"></span></span>
          <i style="display:inline-block;vertical-align: baseline;" class="far fa-clock"></i>
        </span>
        <strong style="font-size: 25px;" name="currentSalat">
          <span class="currentSalat-name">الأن صلاة</span>
          &nbsp;
          
          <span id="currentSalat" style="display: inline" title="current pray"></span>
        </strong>
        <span name="nextSalaat">
          <span>الصلاة القادمة</span>
          &nbsp;
          
          <span id="nextSalat" style="display: inline"></span>
        </span>

        <!-- <h2> بقي على الصلاة القادمة </h2>
                    <h2 name="window.nextSalat.innerText">00:00</h2> -->
      </header>

      <div class="grid">
        <div class="prayTimes">
          <p> الفجر </p>
          <p name="fajurAdhan"> 
            {{ timesCopy[0] }}
            <span v-if="loadingCircle" class="loadingCircle"></span>
          </p>
        </div>
        <div class="prayTimes">
          <p> الشروق </p>
          <p name="shorokTime"> 
            {{ timesCopy[1] }}
            <span v-if="loadingCircle" class="loadingCircle"></span>
          </p>
        </div>
        <div class="prayTimes">
          <p> الظهر </p>
          <p name="duharAdhan">
            {{ timesCopy[2] }}
            <span v-if="loadingCircle" class="loadingCircle"></span>
          </p>
        </div>
        <div class="prayTimes">
          <p> العصر </p>
          <p name="asurAdhan">
          {{ timesCopy[3] }}
          <span v-if="loadingCircle" class="loadingCircle"></span>
        </p>

        </div>
        <div class="prayTimes">
          <p> المغرب </p>
          <p name="mugrbbAdhan">
          {{ timesCopy[4] }}
          <span v-if="loadingCircle" class="loadingCircle"></span>
        </p>
        </div>
        <div class="prayTimes">
          <p> العشاء </p>
          <p name="ishaAdhan">
          {{ timesCopy[5] }}
          <span v-if="loadingCircle" class="loadingCircle"></span>
        </p>
        </div>
      </div>

      <footer>
        <h2> قيام الليل </h2>
        <p><span>يبدأ من</span>&nbsp;&nbsp;&nbsp;<span name="qeyamStart"> بعد صلاة العشاء </span> </p>
        <p><span>نهاية الثلث الاخير</span>&nbsp;&nbsp;&nbsp;<span name="qeyamLast"> عند طلوع الفجر </span> </p>
      </footer>
    </div>
    <br><br>

  </div>
</template>
<!-- <span v-if="loadingCircle" class="loadingCircle"></span> -->
<script>
import axios from 'axios'
import timeZone from "./timeZone.vue"

export default {
  name: "homeActive",
  data() {
    return {
      loadingCircle: true,
      // loadingState: true,
      // mainTime
      timeZone: "",
      timeZoneCmp: false,
      manualy: {
        hrs: new Date().getHours(),
        mins: new Date().getMinutes()
      },
      // mainPraysTimes
      times: ["", "", "", "", "", ""],
      timesCopy: ["", "", "", "", "", ""],
      countryName: "Saudi",
      cityName: "Riyadh",
      bigCountry: "Asia",
      // keepLocalStorage: false,
      testTimer: this.timeZone,
      testTimerCopy: this.timeZone,

     }
  },
  watch: {
    // used for show loading circle while theres no data
    testTimer() {
      if(this.times[0] != "") {
        this.loadingCircle = false;
      }
    }
  },
  methods: {
    
    // time converter 24 <-> 12
    checktimer(val) {
      if(this.$store.state.hsys === true || this.$store.state.hsys === "true") {
        var h = +val.slice(0,2);
        if(h > 12) {return `${h - 12}:${val.slice(3,)} م`;}
        else { return `${val} ص`; }
      }
      else {return val;}
    },
    getTimeZoneFromEmit(data) {
      this.bigCountry = data.split(":")[0];
      this.countryName = data.split(":")[1];
      this.cityName = data.split(":")[2];
      window.localStorage.setItem("timeZone", this.bigCountry + ":" + this.countryName + ":" + this.cityName);
      
      // this.keepLocalStorage = data[3];
      this.timeZoneCmp = false;
      console.log("timeZone cmp closed, now getting the prayer times... [myAxios function]");
      this.myAxios(); // get pray times
      console.log("myAxios function finished [getting prays times], now timeInAxios to get clock of the current location...");
      //this.timeInAxios();
     setInterval(() => {
        this.timeInAxios();
        console.log("- //interval = timeInAxios updated from getTimeZoneFromEmit()");
      }, 10000);
    },
    calculationTimeF(h, m) {
      // const prayTimesEl = document.querySelectorAll(".prayTimes"),
      var prayTimesEl = this.times,
        prayDivs = document.querySelectorAll(".prayTimes"),
        // currentTime = this.testTimer,
        currentSalat = document.getElementById("currentSalat"),
        nextSalat = document.getElementById("nextSalat"),
        h_currentTime = +h, //currentTime.split(":")[0],
        m_CurrentTime = +m,//currentTime.split(":")[1];
        both_currentTime = (+h_currentTime * 60) + +m_CurrentTime;

      var aryy = [];
      var a, b, c;
      //console.clear();

      for (var x = 0; x < prayTimesEl.length; x++) {
        a = prayTimesEl[x].split(":")[0];
        b = prayTimesEl[x].split(":")[1];
        c = (+a * 60) + +b;
        aryy.push(c);
      }
      prayTimesEl = aryy;

      prayDivs.forEach(el => { el.classList.remove("active") });

      //////////////////////////////////////
      for (var y = 0; y < prayTimesEl.length; y++) {

        /**
         * time: 1206
         * 279, 381, 
         * 794, 1015, 
         * 1205, 1295
         */
        // both 125 <= now 279 & y=0
        if (both_currentTime <= prayTimesEl[y] &&
          y == 0) {
          if (prayTimesEl[y] == both_currentTime) {
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[y + 1].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
          else if (both_currentTime < prayTimesEl[y]) {
            currentSalat.innerText = prayDivs[5].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            prayDivs[5].classList.add("active");
            break;
          }
        }
        // both 1296 >= now 1295 & next == undefined
        else if (both_currentTime >= prayTimesEl[y] &&
          prayTimesEl[y + 1] == undefined) {
          if (both_currentTime == prayTimesEl[y]) {
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[0].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
          else if (both_currentTime > prayTimesEl[y]) {
            // y = y+1;
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[0].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
          else if (prayTimesEl[y] < both_currentTime) {
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[0].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
        }
        // next 1015 > both 940 >= now 794 & next != undefined
        else if (both_currentTime >= prayTimesEl[y] &&
          both_currentTime < prayTimesEl[y + 1] &&
          prayTimesEl[y + 1] != undefined) {
          if (prayTimesEl[y] == both_currentTime) {
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[y + 1].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
          else {
            currentSalat.innerText = prayDivs[y].querySelectorAll("p")[0].innerText;
            nextSalat.innerText = prayDivs[y + 1].querySelectorAll("p")[0].innerText;
            prayDivs[y].classList.add("active");
            break;
          }
        }
        // else {console.warn("an undefined time");}
      }
    }, // get clock, err => open window
    timeInAxios() {
      // this function is getting thr clock time 
      // and pass it into the testTimer var
      //                ====== online deploying ======
      axios.get(`https://api.aladhan.com/v1/currentTime?zone=${this.bigCountry}/${this.cityName}`)
      // this.loadingState = false;
      // axios.get("http://localhost:8080/myapi.json")
        .then(myData => {
          // this.loadingState = false;
          //                ====== online deploying ======
          const fullTime = JSON.stringify(myData.data.data).replace(/"/g, '');
          //console.log("hello world\n" + JSON.stringify(myData.data.data.theTimer));
          // const fullTime = JSON.stringify(myData.data.data.theTimer).replace(/"/g, '');
          const minuts_FullTime = fullTime.slice(3, );
          this.testTimer = fullTime;
          this.testTimerCopy = this.checktimer(fullTime);
          this.calculationTimeF(fullTime.slice(0, 2), minuts_FullTime);
        })
        .catch(err => {
          //err == "AxiosError: Network Error" ? console.log(true) : console.log(false);
          console.log("pray clock error: " + err + "\nreopen timezoneCmp cuz error in the vars");
          //this.timeZoneCmp = true;
          //this.timeInAxios();
        });
    }, // getting prays times 
    myAxios() {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate();
      //   console.log(y, m, d);
        // this.loadingState = false;
      // getting prays times
      //                    ====== online deploying ======
      axios.get(`https://api.aladhan.com/v1/timingsByCity/${d}-${m}-${y}?city=${this.cityName}&country=${this.countryName}&method=8`)
      // axios.get(`${location.href}myapi.json`)
        .then(res => {
          /** 
           *                ====== offline deploying ======
          */
          // this.times[0] = JSON.stringify(res.data.data.data.timings.Fajr).replace(/"/g, '');
          // this.times[1] = JSON.stringify(res.data.data.data.timings.Sunrise).replace(/"/g, '');
          // this.times[2] = JSON.stringify(res.data.data.data.timings.Dhuhr).replace(/"/g, '');
          // this.times[3] = JSON.stringify(res.data.data.data.timings.Asr).replace(/"/g, '');
          // this.times[4] = JSON.stringify(res.data.data.data.timings.Maghrib).replace(/"/g, '');
          // this.times[5] = JSON.stringify(res.data.data.data.timings.Isha).replace(/"/g, '');
          this.times[0] = JSON.stringify(res.data.data.timings.Fajr).replace(/"/g, '');
          this.times[1] = JSON.stringify(res.data.data.timings.Sunrise).replace(/"/g, '');
          this.times[2] = JSON.stringify(res.data.data.timings.Dhuhr).replace(/"/g, '');
          this.times[3] = JSON.stringify(res.data.data.timings.Asr).replace(/"/g, '');
          this.times[4] = JSON.stringify(res.data.data.timings.Maghrib).replace(/"/g, '');
          this.times[5] = JSON.stringify(res.data.data.timings.Isha).replace(/"/g, '');
          
            // used for time converter function
            this.timesCopy[0] = this.checktimer(this.times[0]);
            this.timesCopy[1] = this.checktimer(this.times[1]);
            this.timesCopy[2] = this.checktimer(this.times[2]);
            this.timesCopy[3] = this.checktimer(this.times[3]);
            this.timesCopy[4] = this.checktimer(this.times[4]);
            this.timesCopy[5] = this.checktimer(this.times[5]);
          
          console.log("- myaxios function applyied from GET");
        })
        .catch(err => {
          console.log("prayTime err: " + err + "\n myaxios function [getting prays times] got ERROR");
        })
    }
  },
  components: {
    timeZone
  },
  created() {
    console.log("home created");
    if (window.localStorage.getItem("timeZone") == null ||
      window.localStorage.getItem("timeZone") == undefined) {
      // axios.get("https://jsonplaceholder.typicode.com/posts")
      // theres no loclaStoreage, get api
      axios.get('https://api.ipregistry.co/?key=tryout')
      // axios.get('https://ltskurage.000webhostapp.com/Test/api/ipregistry-co.json')
        .then(response => {
          this.countryName = response.location.country.name;
          this.bigCountry = response.location.continent.name;
          this.cityName = response.location.city;
          window.localStorage.setItem("timeZone", this.bigCountry + ":" + this.countryName + ":" + this.cityName);
          this.myAxios(); // pray times
          setInterval(() => {
            this.timeInAxios(); // get clock with calculation
            console.log("- timeInAxios updated from created hook by API");
          }, 10000);
        })
        .catch(err => {
          console.log("ip err: " + err + "\n the localSorage: " + this.bigCountry + ":" + this.countryName + ":" + this.cityName);
          console.log("ipregistry error, reopen time zone cmp");
          //this.fixErrorTimeZone();
          this.timeZoneCmp = true;
        })
    }
    else {
      this.bigCountry = window.localStorage.getItem("timeZone").split(":")[0];
      this.countryName = window.localStorage.getItem("timeZone").split(":")[1];
      this.cityName = window.localStorage.getItem("timeZone").split(":")[2];
      console.log("at created hook Else condation, localStorage !null: " + this.bigCountry + "/" + this.countryName + "/" + this.cityName);

      this.myAxios(); // getting pray times
      setInterval(() => {
        this.timeInAxios(); // get clock with calculation
        console.log("- //interval =  timeInAxios updated from created hook by LCL-STRG");
      }, 10000);
    }




    /**
     * 
      fetching time clock
      https://api.aladhan.com/v1/currentTime?zone${currentContinent}/${currentCity}`)

      fetching the prayer times
      https://api.aladhan.com/v1/timingsByCity?city=${currentCity}&country=${currentCountry}&method=8
     * 
     */
  }
}
</script>

<style scoped>
.loadingCircle {
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 50px;
  border: 3px solid #fff;
  border-top-color: #0000;
  animation: loadingCircle 1s infinite linear;
}
@keyframes loadingCircle {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}

.fadee-enter-active,
.fadee-leave-active {
  transition: opacity .3s;
}

.fadee-enter,
.fadee-leave-to
/* .fade-leave-active below version 2.1.8 */
{opacity: 0;}

.spin-animate {
  animation: rolling 1s linear infinite;
}
@keyframes rolling {
  from {transform: rotate(0);}
  to {transform: rotate(360deg);}
}

</style>